import { CircularProgress } from '@mui/material';

interface LoaderAdornmentProps {
  isLoading?: boolean;
}

const LoaderAdornment = ({ isLoading = false }: LoaderAdornmentProps) => {
  return isLoading ? (
    <CircularProgress
      color='inherit'
      size={20}
      sx={{ color: (theme) => theme.palette.grey[300] }}
    />
  ) : null;
};

export default LoaderAdornment;
